import * as React from 'react';
import { Box, Typography, Divider } from '@mui/material';

export default function PageTitle(props) {
  return (
    <>
      <Box
        sx={{
          backgroundSize: '100%',
          marginBottom: '2vh',
          color: 'primary.main',
        }}
      >
        <Typography variant='h4'>{props.title}</Typography>
        <br />
        <Divider />
      </Box>
    </>
  );
}
